import React from "react";
export default (parent, stateLabel) => (Component) => {
  return React.cloneElement(Component, {
    value: parent.state[stateLabel],
    onChange: e => parent.setState({ [stateLabel]: e.target.value })
  });
}


// WEBPACK FOOTER //
// ./src/custom/makeInput.js